import React, { ReactNode } from 'react';
import { Text, TextSize } from 'shared/ui/Text/Text';
import { formatNumber } from 'shared/lib/utils/utils';
import cls from './Wallet.module.scss';

interface WalletProps {
    className?: string,
    name: string,
    icon: ReactNode;
    sum: number,
    onClick?: () => void
}
export const Wallet: React.FC<WalletProps> = ({
    className, sum, icon, name,
}) => (
    <div className={cls.wallet}>
        <div className={cls.name}>
            {icon}
            <Text className={cls.notion} color="#FFFFFF" size={TextSize.text_16_600}>{name}</Text>
        </div>
        <div className={cls.walletValue}>
            <Text className={cls.notion} color="#000000A6" size={TextSize.text_16}>{formatNumber(sum)} ₽</Text>
        </div>
    </div>
);
